<template>
  <div v-if="this.loginUserSensorArrayAllHasData.length != 0">

    <div class="tickerToggle" style="margin-top: 0.25rem; margin-right: 0.25rem;">
      <b-button @click="toggleTicker" size="sm" :class="(this.showTicker)? 'text-blue-dark bg-blue-lighter pb-0 pt-0 pl-1 pr-1 fontSizeDot7' : 'bg-blue-dark text-blue-lighter pb-0 pt-0 pl-1 pr-1 fontSizeDot7'">
        {{(this.showTicker)? "X" : "Ticker" }}
      </b-button>
    </div>

    <tinkList v-touch:swipe.stop v-touch:touchhold="toggleTicker" v-if="this.showTicker && this.loginUserSensorArrayAllHasData.length != 0" :autoRotate="0" :controls="!this.hasTouch" :start="0" :show="1" controlsPosition="middle" :controlsHeight="0.5" :showMessage="true" rowClass="tickerRow" :class="(hasTouch)? 'bg-blue-dark text-blue-lighter': 'bg-blue-dark text-blue-lighter'" :lastLinePrevWidth="true">

      <tinkListItem class="tickerSensorBox" v-for="(sensor,index) in loginUserSensorArrayAllHasData" :key="`sensor_${index}`">

        <div class="gothic text-center tickerDeviceName fontSizeDot7 border border-bottom-0">

          <router-link :to="{ name: 'tinkDevice', params: { did: loginUserDeviceListAll[sensor.device].id} }" custom v-slot="{ navigate }">
            <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
              {{ loginUserDeviceListAll[sensor.device].name }}
            </span>


          </router-link>

        </div>

        <div class="gothic text-center border border-bottom-0 bg-blue-lighter text-blue-dark fontSizeDot7">
          <router-link :to="{ name: 'tinkSensor', params: { sid: sensor.id} }" custom v-slot="{ navigate }">
            <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
              {{sensor.name}}
            </span>
          </router-link>
        </div>

        <div class="p-1 gothic fontSizeDot7 border" v-b-tooltip.hover.bottom :title="(sensor.lastValues)? dateToString(sensor.lastValues.t.toDate()): ''">
          <div v-for="(sensorValue, valueIndex) in sensor.values" :key="`sensor_${index}_${valueIndex}`">
            <div v-if="!sensorValue.hold" class="d-flex flex-nowrap justify-content-between tickerValue">
              <div class="tickerValueName">{{sensorValue.name}}</div>
              <div class="fontSizeDot8 text-light">{{sensor.lastValues.v[valueIndex]}}</div>
              <div class="tickerValueUnit" v-if="sensorValue.unit">{{sensorValue.unit}}</div>
            </div>
          </div>
        </div>

      </tinkListItem>
    </tinkList>
  </div>
</template>
<script>
import uiUtil from "@/mixins/util.js"
import user from "@/mixins/user.js"

import {tinkList, tinkListItem} from "@/components/common/tinkList.vue"

import { mapState } from "vuex"
import { mapSetter } from "@/plugins/vuexUtils.js"
export default {
  name: "ticker",
  mixins: [user, uiUtil],
  components: {
    tinkList,
    tinkListItem
  },
  data() {
    return {
      showTicker: false,
    }
  },
  mounted: function() {
    if(this.$cookies.isKey("showTicker")) {
      this.showTicker = JSON.parse(this.$cookies.get("showTicker"));
    }
  },
  updated: function() {
  },
  methods: {
    toggleTicker: function() {
      this.showTicker = ! this.showTicker;
      this.$log.debug("ticker.vue", "toggleTicker", "showTicker", this.showTicker)
      this.$cookies.set("showTicker", JSON.stringify(this.showTicker));
    },
  },
}
</script>
<style>

.tickerToggle { position : absolute; text-align: center; z-index: 1005; right:0; }

.tickerSensorBox { border-width: 0rem; height : auto; margin-right: 0.5rem; margin-bottom: 0.5rem; width: 7.5rem; max-width: 10rem;}
.tickerDeviceName { line-height: 100%; overflow:hidden; text-overflow: ellipsis; white-space: nowrap; padding: 0.3rem 0.2rem 0.4rem 0.2rem; }
.tickerDeviceName:hover { text-decoration : underline; }
.tickerSensorName { line-height: 100%; overflow:hidden; text-overflow: ellipsis; white-space: nowrap; padding: 0.3rem 0.2rem 0.4rem 0.2rem; }
.tickerSensorName:hover { text-decoration : underline }

.tickerValueName { padding-top: 0.1rem; }
.tickerValueUnit { padding-top: 0.1rem; }
</style>
